var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('b-button',{staticClass:"backToTop bg-white text-secondary rounded-circle border-0 p-2 align-items-center justify-content-center darkenOnHover",on:{"click":function($event){return _vm.scrollTop()}}},[_c('b-icon',{attrs:{"icon":"arrow-up","font-scale":"1.4em"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }